export const env = {
  auth0: {
    domain: import.meta.env.VITE_AUTH0_DOMAIN ?? '',
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID ?? '',
    audience: import.meta.env.VITE_AUTH0_AUDIENCE ?? '',
    customClaimsNamespace: import.meta.env.VITE_AUTH0_CUSTOM_CLAIMS_NAMESPACE ?? '',
    tinyMceApiKey: import.meta.env.VITE_TINYMCE_API_KEY ?? '',
  },
};

export function hasAuth0Config() {
  return Boolean(env.auth0.domain && env.auth0.clientId);
}
